import React from "react";
import { colors } from '../../../../theme/colors';
import {
  Button,
  Divider,
  Grid,
  TextField,
  Tooltip,
  Typography,
  Snackbar,
  Alert,
  MenuItem,
  CircularProgress,
  Box,
} from "@mui/material";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import {
  FormContainer,
  UploadBox,
  CustomPaper,
  RightSection,
  CustomPhoneInput,
  SectionHeader,
} from "./style";
import { CustomTextField } from "../../../../components/common-components/CustomTextField";
import {
  CustomSelect,
  CustomSelectField,
} from "../../../../components/common-components/CustomSelect";
import UploadFile from "./UploadFile";
import UploadProfilePic from "./UploadProfilePic";
import FieldErrorMessage from "../../../../components/common-components/FieldErrorMessage";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "react-phone-input-2/lib/style.css";

import { StyledCircularProgress } from "../reports/style";
import useInterviewScheduling from "./useInterviewScheduling";
import { applyCurrentTimeIfToday } from "../adjustPickerDateForToday";
import { CustomStyledCircularProgress } from "../../../../components/common-components/CustomStyledCircularProgress";
import DuplicateEmailModal from "../../../../components/common-components/DuplicateEmailModal";

const ScheduleInterview = () => {
  const {
    profilePic,
    allRoles,
    startDate,
    clearFile,
    fileRef,
    fileRef1,
    clearProfilePic,
    phomeErrorMessage,
    loginUserRoles,
    recruiter,
    allUserList,
    snackbar,
    isSubmitting,
    inputRef,
    now,
    allRecruiterList,
    formik,
    levelOptions,
    languageOptions,
    interviewTypeOptions,

    setStartDate,
    setSnackbar,
    setProfilePic,
    setRecruiter,
    source,
    setSource,
    allSourceList,
    allSourceUserList,
    handleSourceInputChange,
    handleGetMoreSourceOnScroll,
    setFilterOptions,
    setOnChangeValidation,
    handleInputChange,
    validatePhoneNumber,
    handleGetMoreUserOnScroll,
    handleCloseSnackbar,
    handleSetProfilePic,
    handleGetJobDescription,
    handleGetResume,
    duplicateModalOpen,
    duplicateData,
    handleConfirmSchedule,
    handleCloseDuplicateModal,
  } = useInterviewScheduling();

  return (
    <FormContainer>
      <Snackbar
        open={snackbar.open}
        autoHideDuration={3000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert
          onClose={() => setSnackbar((prev) => ({ ...prev, open: false }))}
          severity={snackbar.severity}
          sx={{ width: "100%" }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
      <Typography variant="h5" fontWeight="bold" gutterBottom color={colors.primary}>
        Schedule Interview
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
        Fill in the candidate details and interview preferences below to schedule an AI interview.
      </Typography>
      <form onSubmit={formik.handleSubmit}>
        <Grid container spacing={2}>
          <Grid item xs={12} md={4}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <CustomPaper>
                  <UploadBox>
                    <UploadProfilePic
                      getProfilePic={handleSetProfilePic}
                      profilePic={profilePic}
                      setProfilePic={setProfilePic}
                      inputRef={inputRef}
                      clearProfilePic={clearProfilePic}
                    />
                    <Typography variant="body2" className="file_format">
                      Allowed *.jpeg, *.jpg, *.png
                      <br />
                      max size of 3 Mb
                    </Typography>
                    <FieldErrorMessage error={formik.errors.profilePic} />
                  </UploadBox>
                </CustomPaper>
              </Grid>
              <Grid item xs={12}>
                <UploadFile
                  handleGetFile={handleGetResume}
                  label="Resume"
                  filename={formik.values.resume.name}
                  clearFile={clearFile}
                  fileRef={fileRef1}
                />
                <FieldErrorMessage error={formik.errors.resume} />
              </Grid>
              <Grid item xs={12}>
                <UploadFile
                  handleGetFile={handleGetJobDescription}
                  label="Job Description"
                  filename={formik.values.jobDescription?.name}
                  clearFile={clearFile}
                  fileRef={fileRef}
                />
                <FieldErrorMessage error={formik.errors.jobDescription} />
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} md={8}>
            <RightSection>
              <Grid container spacing={2}>
              <Grid item xs={12}>
                  <Divider>
                    <SectionHeader>Candidate Information</SectionHeader>
                  </Divider>
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    className="required_field"
                    fullWidth
                    label="Full name*"
                    placeholder="Full name"
                    variant="outlined"
                    id="candidateName"
                    name="candidateName"
                    value={formik.values.candidateName}
                    onChange={formik.handleChange}
                  />
                  <FieldErrorMessage error={formik.errors.candidateName} />
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    fullWidth
                    label="Email address*"
                    type="email"
                    variant="outlined"
                    id="candidateEmail"
                    name="candidateEmail"
                    value={formik.values.candidateEmail}
                    onChange={formik.handleChange}
                  />
                  <FieldErrorMessage error={formik.errors.candidateEmail} />
                </Grid>

                <Grid item xs={6}>
                  <CustomPhoneInput
                    country={"us"}
                    value={formik.values.candidatePhone}
                    onChange={(phone, country) => {
                      validatePhoneNumber(phone, country);
                    }}
                    inputStyle={{
                      width: "100%",
                    }}
                    inputProps={{
                      name: "candidatePhone",
                      id: "candidatePhone",
                      autoComplete: "off",
                    }}
                  />
                  <FieldErrorMessage
                    error={
                      formik.errors.candidatePhone
                        ? formik.errors.candidatePhone
                        : phomeErrorMessage
                    }
                  />
                </Grid>
                {console.log("formik.values.applyFor", formik.values.applyFor)}

                <Grid item xs={6}>
                  <CustomSelect
                    fullWidth
                    options={allRoles.data?.data || []}
                    getOptionLabel={(option) => {
                      return option?.role;
                    }}
                    value={formik.values.applyFor}
                    onChange={(event, value) => {
                      formik.setFieldValue("applyFor", value);
                    }}
                    renderInput={(params) => (
                      <CustomSelectField
                        {...params}
                        label="Apply for*"
                        variant="outlined"
                        fullWidth
                        InputProps={{
                          ...params.InputProps,
                          endAdornment: (
                            <>
                              {allRoles.isLoading ? (
                                <CircularProgress color="inherit" size={20} />
                              ) : null}
                              {params.InputProps.endAdornment}
                            </>
                          ),
                        }}
                      />
                    )}
                    renderOption={(props, option) => (
                      <MenuItem
                        {...props}
                        sx={{
                          "&:hover": {
                            backgroundColor: `${colors.primary} !important`,
                            color: "#fff",
                          },
                        }}
                      >
                        {option.role || ""}
                      </MenuItem>
                    )}
                  />

                  <FieldErrorMessage error={formik.errors.applyFor} />
                </Grid>
                <Grid item xs={12}>
                  <Divider sx={{ mt: 1 }}>
                    <SectionHeader>Location (Optional)</SectionHeader>
                  </Divider>
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    fullWidth
                    label="State"
                    variant="outlined"
                    id="state"
                    name="state"
                    value={formik.values.state}
                    onChange={formik.handleChange}
                  />
                  <FieldErrorMessage error={formik.errors.state} />
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    fullWidth
                    label="City"
                    variant="outlined"
                    id="city"
                    name="city"
                    value={formik.values.city}
                    onChange={formik.handleChange}
                  />
                  <FieldErrorMessage error={formik.errors.city} />
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    fullWidth
                    label="Street"
                    variant="outlined"
                    id="street"
                    name="street"
                    value={formik.values.street}
                    onChange={formik.handleChange}
                  />
                  <FieldErrorMessage error={formik.errors.street} />
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    fullWidth
                    label="Zip code"
                    variant="outlined"
                    id="zip"
                    name="zip"
                    value={formik.values.zip}
                    onChange={formik.handleChange}
                  />
                  <FieldErrorMessage error={formik.errors.zip} />
                </Grid>
                <Grid item xs={12}>
                  <Divider sx={{ mt: 1 }}>
                    <SectionHeader>Interview Setup</SectionHeader>
                  </Divider>
                </Grid>
                {loginUserRoles && (loginUserRoles === "admin" || loginUserRoles === "recruiter") && (
                  <>
                    <Grid item xs={6}>
                      <CustomSelect
                        fullWidth
                        options={allRecruiterList || []}
                        getOptionLabel={(option) => option?.name || ""}
                        value={recruiter}
                        onInputChange={handleInputChange}
                        onBlur={(e) => {
                          if (allRecruiterList.length === 0) {
                            setRecruiter(null);
                            formik.setFieldValue("recruiter", "");
                            formik.setFieldValue("recruiterEmail", "");
                            setFilterOptions((prev) => ({
                              ...prev,
                              page: 1,
                              name: "",
                            }));
                          }
                        }}
                        onChange={(event, value) => {
                          if (value) {
                            setRecruiter(value);
                            formik.setFieldValue("recruiter", value.name);
                            formik.setFieldValue("recruiterEmail", value.email);
                          } else {
                            setRecruiter(null);
                            formik.setFieldValue("recruiter", "");
                            formik.setFieldValue("recruiterEmail", "");
                          }
                        }}
                        renderInput={(params) => (
                          <CustomSelectField
                            {...params}
                            label="Recruiter*"
                            variant="outlined"
                            fullWidth
                            InputProps={{
                              ...params.InputProps,
                              endAdornment: (
                                <>
                                  {allUserList.isLoading ? (
                                    <CircularProgress
                                      color="inherit"
                                      size={20}
                                    />
                                  ) : null}
                                  {params.InputProps.endAdornment}
                                </>
                              ),
                            }}
                          />
                        )}
                        renderOption={(props, option) => (
                          <MenuItem
                            {...props}
                            sx={{
                              "&:hover": {
                                backgroundColor: `${colors.primary} !important`,
                                color: "#fff",
                              },
                            }}
                          >
                            {option.name || ""}
                          </MenuItem>
                        )}
                        ListboxProps={{
                          onScroll: handleGetMoreUserOnScroll,
                          style: {
                            maxHeight: 150,
                            overflow: "auto",
                          },
                        }}
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <TextField
                        fullWidth
                        label="Recruiter Email*"
                        variant="outlined"
                        id="recruiterEmail"
                        disabled
                        name="recruiterEmail"
                        value={formik.values.recruiterEmail}
                      />
                      <FieldErrorMessage error={formik.errors.recruiterEmail} />
                    </Grid>
                  </>
                )}
                <Grid item xs={6}>
                  <Box sx={{ width: "100%" }}>
                    <DatePicker
                      name="startTime"
                      placeholderText="Start Time*"
                      selected={startDate}
                      autoComplete="off"
                      onChange={(date) => {
                        const next = date
                          ? applyCurrentTimeIfToday(date)
                          : null;
                        if (next) {
                          formik.setFieldValue("startTime", next.toISOString());
                          const autoEnd = new Date(next.getTime() + 48 * 60 * 60 * 1000);
                          formik.setFieldValue("endTime", autoEnd.toISOString());
                        } else {
                          formik.setFieldValue("startTime", null);
                          formik.setFieldValue("endTime", null);
                        }
                        setStartDate(next);
                      }}
                      showTimeSelect
                      timeFormat="HH:mm"
                      timeIntervals={1}
                      dateFormat="MMMM d, yyyy h:mm aa"
                      minDate={now}
                      minTime={(() => {
                        const today = new Date();
                        if (!startDate) return today;
                        const startIsToday =
                          startDate.getFullYear() === today.getFullYear() &&
                          startDate.getMonth() === today.getMonth() &&
                          startDate.getDate() === today.getDate();
                        return startIsToday ? today : new Date(0, 0, 0, 0, 0);
                      })()}
                      maxTime={(() => {
                        const t = new Date();
                        return new Date(
                          t.getFullYear(),
                          t.getMonth(),
                          t.getDate(),
                          23,
                          59,
                        );
                      })()}
                      portalId="root"
                    />
                  </Box>
                  <FieldErrorMessage error={formik.errors.startTime} />
                </Grid>

                <Grid item xs={6}>
                  <CustomSelect
                    fullWidth
                    options={allSourceList || []}
                    getOptionLabel={(option) => option?.name || ""}
                    value={source}
                    onInputChange={handleSourceInputChange}
                    onBlur={(e) => {
                      if (allSourceList.length === 0 && !source) {
                        setSource(null);
                        formik.setFieldValue("source", "");
                      }
                    }}
                    onChange={(event, value) => {
                      if (value) {
                        setSource(value);
                        formik.setFieldValue("source", value.name);
                      } else {
                        setSource(null);
                        formik.setFieldValue("source", "");
                      }
                    }}
                    renderInput={(params) => (
                      <CustomSelectField
                        {...params}
                        label="Sourcer"
                        variant="outlined"
                        fullWidth
                        InputProps={{
                          ...params.InputProps,
                          endAdornment: (
                            <>
                              {allSourceUserList.isLoading ? (
                                <CircularProgress color="inherit" size={20} />
                              ) : null}
                              {params.InputProps.endAdornment}
                            </>
                          ),
                        }}
                      />
                    )}
                    renderOption={(props, option) => (
                      <MenuItem
                        {...props}
                        sx={{
                          "&:hover": {
                            backgroundColor: `${colors.primary} !important`,
                            color: "#fff",
                          },
                        }}
                      >
                        {option.name || ""}
                      </MenuItem>
                    )}
                    ListboxProps={{
                      onScroll: handleGetMoreSourceOnScroll,
                      style: {
                        maxHeight: 150,
                        overflow: "auto",
                      },
                    }}
                  />
                </Grid>

                <Grid item xs={6}>
                  <CustomSelect
                    fullWidth
                    options={[
                      { label: "Yes", value: "yes" },
                      { label: "No", value: "no" },
                    ]}
                    getOptionLabel={(option) => option.label}
                    value={
                      formik.values.useCustomQuestion
                        ? {
                            label:
                              formik.values.useCustomQuestion === "yes"
                                ? "Yes"
                                : "No",
                            value: formik.values.useCustomQuestion,
                          }
                        : null
                    }
                    onChange={(event, value) => {
                      formik.setFieldValue(
                        "useCustomQuestion",
                        value ? value.value : "",
                      );
                      if (value?.value !== "yes") {
                        formik.setFieldValue("experienceLevel", "");
                      }
                    }}
                    onBlur={() =>
                      formik.setFieldTouched("useCustomQuestion", true)
                    }
                    renderInput={(params) => (
                      <CustomSelectField
                        {...params}
                        label="Custom Question*"
                        variant="outlined"
                        fullWidth
                      />
                    )}
                    renderOption={(props, option) => (
                      <MenuItem
                        {...props}
                        sx={{
                          "&:hover": {
                            backgroundColor: `${colors.primary} !important`,
                            color: "#fff",
                          },
                        }}
                      >
                        {option.label}
                      </MenuItem>
                    )}
                  />
                  <FieldErrorMessage error={formik.errors.useCustomQuestion} />
                </Grid>

                <Grid item xs={6}>
                  <Tooltip
                    title={
                      formik.values.useCustomQuestion !== "yes"
                        ? "Select 'Yes' for Custom Question to enable this field"
                        : ""
                    }
                    placement="top"
                    arrow
                  >
                    <span style={{ display: "block" }}>
                  <CustomSelect
                    fullWidth
                    options={levelOptions}
                    getOptionLabel={(option) => option?.label || option || ""}
                    value={
                      formik.values.experienceLevel
                        ? levelOptions.find(
                            (opt) =>
                              opt.value === formik.values.experienceLevel,
                          ) || null
                        : null
                    }
                    onChange={(event, value) => {
                      formik.setFieldValue(
                        "experienceLevel",
                        value?.value || value || "",
                      );
                    }}
                    disabled={formik.values.useCustomQuestion !== "yes"}
                    renderInput={(params) => (
                      <CustomSelectField
                        {...params}
                        label="Experience Level"
                        variant="outlined"
                        fullWidth
                        helperText={
                          formik.values.useCustomQuestion !== "yes"
                            ? "Enabled when Custom Question is Yes"
                            : ""
                        }
                        InputProps={{
                          ...params.InputProps,
                          endAdornment: (
                            <>
                              {formik.values.useCustomQuestion !== "yes" && (
                                <LockOutlinedIcon sx={{ color: "#919EAB", fontSize: 18, mr: 0.5 }} />
                              )}
                              {params.InputProps.endAdornment}
                            </>
                          ),
                        }}
                      />
                    )}
                    renderOption={(props, option) => (
                      <MenuItem
                        {...props}
                        sx={{
                          "&:hover": {
                            backgroundColor: `${colors.primary} !important`,
                            color: "#fff",
                          },
                        }}
                      >
                        {option.label || ""}
                      </MenuItem>
                    )}
                  />
                    </span>
                  </Tooltip>
                </Grid>

                <Grid item xs={6}>
                  <CustomSelect
                    fullWidth
                    options={languageOptions}
                    getOptionLabel={(option) => option?.label || ""}
                    value={
                      languageOptions.find(
                        (opt) => opt.value === formik.values.interviewLanguage,
                      ) || null
                    }
                    onChange={(event, value) => {
                      formik.setFieldValue(
                        "interviewLanguage",
                        value?.value || "en",
                      );
                    }}
                    renderInput={(params) => (
                      <CustomSelectField
                        {...params}
                        label="Interview Language"
                        variant="outlined"
                        fullWidth
                      />
                    )}
                    renderOption={(props, option) => (
                      <MenuItem
                        {...props}
                        sx={{
                          "&:hover": {
                            backgroundColor: `${colors.primary} !important`,
                            color: "#fff",
                          },
                        }}
                      >
                        {option.label}
                      </MenuItem>
                    )}
                  />
                </Grid>

                <Grid item xs={6}>
                  <CustomSelect
                    fullWidth
                    options={interviewTypeOptions}
                    getOptionLabel={(option) => option?.label || ""}
                    value={
                      formik.values.interviewType
                        ? interviewTypeOptions.find(
                            (opt) => opt.value === formik.values.interviewType,
                          ) || null
                        : null
                    }
                    onChange={(event, value) => {
                      formik.setFieldValue("interviewType", value?.value || "");
                    }}
                    renderInput={(params) => (
                      <CustomSelectField
                        {...params}
                        label="Interview Type"
                        variant="outlined"
                        fullWidth
                      />
                    )}
                    renderOption={(props, option) => (
                      <MenuItem
                        {...props}
                        sx={{
                          "&:hover": {
                            backgroundColor: `${colors.primary} !important`,
                            color: "#fff",
                          },
                        }}
                      >
                        {option.label || ""}
                      </MenuItem>
                    )}
                  />
                </Grid>

                <Grid item xs={12}>
                  <Divider sx={{ mt: 1 }}>
                    <SectionHeader>Additional Notes</SectionHeader>
                  </Divider>
                </Grid>
                <Grid item xs={12}>
                  <CustomTextField
                    label="Custom Questions for Candidate"
                    placeholder="Enter specific questions you want the interviewer to ask the candidate (optional)"
                    fullWidth
                    multiline
                    rows={2}
                    name="candidateQuestions"
                    value={formik.values.candidateQuestions}
                    onChange={formik.handleChange}
                    disabled={isSubmitting}
                    sx={{
                      color: "#000",
                      "& .MuiOutlinedInput-root": {
                        borderRadius: 2,
                        color: "#000",
                      },
                    }}
                  />
                </Grid>

                <Grid item xs={12} textAlign="end">
                  {isSubmitting ? (
                    <Button className="submit_btn">
                      Scheduling…{" "}
                      <CustomStyledCircularProgress
                        sx={{ color: "#fff !important", ml: 1 }}
                        size={18}
                      />
                    </Button>
                  ) : (
                    <Button
                      className="submit_btn"
                      variant="contained"
                      color="primary"
                      type="submit"
                      endIcon={<ArrowForwardIcon />}
                      onClick={() => {
                        setOnChangeValidation(true);
                      }}
                    >
                      Schedule Interview
                    </Button>
                  )}
                </Grid>
              </Grid>
            </RightSection>
          </Grid>
        </Grid>
      </form>
      <DuplicateEmailModal
        open={duplicateModalOpen}
        handleClose={handleCloseDuplicateModal}
        handleContinue={handleConfirmSchedule}
        duplicateData={duplicateData}
        loading={isSubmitting}
      />
    </FormContainer>
  );
};

export default ScheduleInterview;
